export default __webpack_public_path__ + "static/chetwood_logo-d4f2446db971ba539b005eb4f4d39b5e.svg";